import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { SVGComponent } from '@/types/types';
import { useState } from 'react';

interface PROPS {
  Icon: SVGComponent;
  text: string;
  onClick: () => Promise<void>;
}

export function G_BUTTON__image_asset_create_base({ Icon, text, onClick }: PROPS) {
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const [is_loading, set_is_loading] = useState(false);
  /*
   * EVENTS
   */
  async function on_click_internal() {
    set_is_loading(true);

    await onClick();

    set_is_loading(false);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled || is_loading;
  }

  return (
    <UI_PRIMITIVE__button onClick={on_click_internal} disabled={is_disabled()} className="w-full truncate px-2" variant="outline-on-component" size={'full-6'}>
      <Icon className="size-3" />
      <span className="truncate text-xs">{text}</span>
    </UI_PRIMITIVE__button>
  );
}
